<template>
	<van-row class="full">
		<div class="pay-confirm-container" v-show="showMain">
			<div class="content">
				<ticket-info
					ref="ticket-info"
					:remarkLimit="remarkLimit"
					:detail="infoDetail"
					:enableUseCompanyTitle="detail.enableUseCompanyTitle"
					@add-organ="addOrgan"
					@select="select"
					@search-organ="searchOrgan"
					@change-type="handleChangeTicketType"
					v-show="ticketAvailebled"></ticket-info>

				<!-- <ticket-input
                        v-show="type==3"
                        ref="ticket-input"
                        :detail="infoDetail"
                        :remarkLimit="remarkLimit"
                        @change-type="handleChangeTicketType"
                        v-if="ticketAvailebled"
                ></ticket-input> -->

				<ticket-notice ref="ticket-notice" :detail="infoDetail" v-show="ticketAvailebled"></ticket-notice>

				<ticket-detail :detail="detail" :type="type"></ticket-detail>
			</div>

			<div class="footer">
				<ticket-confirm :detail="detail" @commit="onCommit"></ticket-confirm>
			</div>
		</div>

		<div class="pay-confirm-container" v-show="!showMain">
			<div class="content">
				<ticket-add v-if="showAdd" @back="onBack" @select="select"></ticket-add>
				<ticket-search v-if="showSearch" @back="onBack" @select="select"></ticket-search>
			</div>
		</div>
	</van-row>
</template>
<script>
import ticketInfo from './components/ticket-info/index'
//import ticketInput from "./components/ticket-input/index";
import ticketNotice from './components/ticket-notice/index'
// import topay from "./components/topay/index";
import ticketDetail from '@/components/ticket-detail/index'
import ticketConfirm from '@/components/ticket-confirm/index'
import apiUnpaidFee from 'api/unpaid-fee'
import apiChooseFee from 'api/choose-fee'
import apiAnonymousPay from 'api/anonymous-pay'
import log from 'utils/log'
import util from 'utils/util'
import db from '@/utils/db'
import TicketAdd from '@/components/ticket-add/index'
import TicketSearch from '@/components/ticker-search/index'
// import { getState } from "utils/state";
import storage from 'good-storage'
import _clonedeep from 'lodash.clonedeep'
import store from '@/store'
import { loadUserInfo } from 'utils/cache'

export default {
	name: 'payConfirm',
	components: {
		TicketSearch,
		TicketAdd,
		ticketInfo,
		ticketDetail,
		ticketConfirm,
		//ticketInput,
		ticketNotice
		// topay
	},
	computed: {
		random() {
			return this.$route.query.random
		},
		api() {
			let flag = this.type
			if (flag === 1) {
				return apiUnpaidFee
			}
			if (flag === 2) {
				return apiChooseFee
			}
			if (flag === 3) {
				return apiAnonymousPay
			}
			return null
		},
		type() {
			let t = this.$route.query.type
			return Number(t)
		}
	},
	data() {
		return {
			detail: {},
			infoDetail: {}, // 为了选择完机构之后，再切换为个人不覆盖原来的订单明细信息和开票信息
			selectOrganInfo: {}, // 存储查找选择或者新增的机构信息
			showMain: true,
			showAdd: false,
			showToPay: false,
			showSearch: false,
			noticeDetail: {},
			topayDetail: {},
			remarkLimit: 100,
			ticketAvailebled: true
		}
	},

	activated() {
		console.log('pay-confirm ---- activated')
		this.getDetail()
		this.setRemarkLimit()
	},

	methods: {
		handleChangeTicketType(ticketType) {
			if (ticketType === '1') {
				this.infoDetail = storage.session.get('pay-ticket', {})
			} else if (ticketType === '2') {
				this.infoDetail = this.selectOrganInfo
			}
		},

		getDetail() {
			let obj = storage.session.get('pay-ticket', {})
			let rawValue =
				obj.enableUseCompanyTitle !== undefined && obj.enableUseCompanyTitle !== null
					? obj.enableUseCompanyTitle
					: this.$route.query.enableUseCompanyTitle
			let enableUseCompanyTitle = rawValue === true || rawValue === 'true'
			obj.enableUseCompanyTitle = enableUseCompanyTitle
			this.detail = obj
			this.infoDetail = _clonedeep(obj)
			this.infoDetail = this.createDefaultTitle(enableUseCompanyTitle, this.infoDetail)
			console.log('infoDetail', this.infoDetail)
			if (this.type == 2) {
				if (this.detail.pendFees[0].ticketTypeId == null) {
					this.ticketAvailebled = false
				}
			}
			this.$refs['ticket-info'].updateTicketInfo(this.infoDetail, enableUseCompanyTitle)
		},
		createDefaultTitle(enableUseCompanyTitle, obj) {
			//用户信息
			let user = loadUserInfo()
			if (user !== null && user !== undefined) {
				//允许显示机构
				if (enableUseCompanyTitle && user.ticketTaxNumber) {
					//todo 若存在默认抬头 便取值默认抬头 否则 抬头为用户名称  仅在税号不为空 才显示为公司
					obj.ticketType = '2'
					obj.name = user.ticketTitle
					obj.taxNumber = user.ticketTaxNumber
					obj.tele = user.tele
				} else {
					obj.ticketType = '1'
					obj.userName = user.userName
				}
				obj.userEmail = user.email
				obj.userMobile = user.tele
			} else {
				obj.titleType = '1'
				obj.userName = user.userName
			}
			return obj
		},
		onCommit() {
			let data
			let nData
			if (this.type == 3) {
				data = this.$refs['ticket-input'].getTicketTitleAndTaxNum()
			} else {
				data = this.$refs['ticket-info'].getTicketTitleAndTaxNum()
			}
			nData = this.$refs['ticket-notice'].getTicketTitleAndTaxNum()

			//let { title, taxNumber, depositBank, tele, bank, address, remark } = data
			let title, taxNumber, depositBank, tele, bank, address, remark
			if (this.detail.enableUseCompanyTitle) {
				const companyData = data || {}
				title = companyData.title
				taxNumber = companyData.taxNumber
				depositBank = companyData.depositBank
				tele = companyData.tele
				bank = companyData.bank
				address = companyData.address
				remark = companyData.remark
			} else {
				let user = loadUserInfo()
				title = user.userName
			}
			let { userMobile, userEmail } = nData
			const currentLang = db.get('sys.public.language.value').value() || 'zh'
			let param = {
				random: this.random,
				allMoney: this.detail.allMoney,
				ticketTitle: title,
				pendFees: this.detail.pendFees,
				userRegNum: taxNumber || this.infoDetail.taxNumber,
				userAddress: address,
				userTele: tele,
				userBank: depositBank,
				userBankNum: bank,
				userMobile: userMobile,
				userEmail: userEmail,
				remark: remark,
				sucUrl: util.getIpUrl(this) + '/result/pay_suc',
				lang: currentLang,
				scene: 'mobile'
			}
			if (this.ticketAvailebled) {
				if (title && title == '中山大学') {
					this.$notify({
						type: 'warning',
						message: this.$t('pay_ticket.title_not_sysu')
					})
					return
				}
				if (title) {
					this.topayDetail = param
					this.ok(param)
				} else {
					this.$notify({
						type: 'warning',
						message: this.$t('message.ticketTitle')
					})
				}
			} else {
				this.topayDetail = param
				this.ok(param)
			}
		},

		ok(param) {
			this.api.submit(param).then(res => {
				console.log(res)
				let divForm = document.getElementsByTagName('divform')
				if (divForm.length) {
					document.body.removeChild(divForm[0])
				}
				const div = document.createElement('divform')
				div.innerHTML = res.data
				document.body.appendChild(div)
				document.forms[0].submit()
			})
		},

		addOrgan() {
			this.showMain = false
			this.showSearch = false
			this.showAdd = true
			this.showToPay = false
		},

		searchOrgan() {
			this.showMain = false
			this.showSearch = true
			this.showAdd = false
			this.showToPay = false
		},

		onBack() {
			this.showMain = true
			this.showSearch = false
			this.showAdd = false
			this.showToPay = false
		},

		select(item) {
			log('select item', item)
			this.selectOrganInfo = _clonedeep(item)
			this.infoDetail = item
			this.onBack()
		},
		setRemarkLimit() {
			apiAnonymousPay.getMaxCountTicketRemark().then(res => {
				let data = res.data
				if (data && data.MAX_COUNT_TICKET_REMARK) {
					this.remarkLimit = parseInt(data.MAX_COUNT_TICKET_REMARK)
				}
			})
		}
	}
}
</script>
<style lang="scss" scoped></style>
